import { useEffect, useState, useCallback } from "react";
import { Box, Button, Image, Text, useDisclosure } from "@chakra-ui/react";
import { getApi } from "common/services/api";
import { HasAccess } from "../../../../common/utils/accessUtils";
import CommonCheckTable from "common/components/checktable";
import { DeleteIcon, SearchIcon, DownloadIcon } from "@chakra-ui/icons";
import feedbackService from "../../services/feedback";
import EditTask from "../../components/jobProfile/editDepartment";
import { useLocation, useNavigate } from "react-router-dom";
import CommonDeleteModel from "common/components/commonDeleteModel";
import JobProfileAdvanceSearch from "../../components/jobProfile/JobProfileAdvanceSearch";
import { deleteApi } from "common/services/api";
import JobProfileView from "../../components/jobProfile/JobProfileView";
import { toast } from "react-toastify";
import AddJobProfile from "../../components/jobProfile/addJobProfile";
import viewIcon from "common/assets/img/viewIcon.png";
import ActionMenu from "common/components/ActionMenu";
import {
  getTableFilters,
  saveTableFilters,
  clearTableFilters,
  getInitialFilterState
} from "common/utils/filterUtils";
import { constant } from "common/constant";
import DateFormatter from "common/utils/dateFormater";
import { globalStyles } from "common/theme/styles";
import CustomStatus from "common/components/status/CustomStatus";
import Rating from "services/Recruit/components/Rating/Rating";
import { JobApplicationData } from "services/Recruit/data/jobApplicationData";
import { recruitConstant } from "services/Recruit/constant";
import StatusDropdown from "common/components/statusDropdown";
import { putApi } from "common/services/api";
import CustomStatusDropdown from "services/Recruit/components/CustomStatusDropdown/CustomStatusDropdown";
import { customDropDownData } from "services/Recruit/data/recruitData";
import { accessModuleTitles } from "common/constant";
import { deleteManyApi } from "common/services/api";
import { applicationStatusLabels } from "common/constant";
import { formatStatus } from "services/Crm/utils/calcUtils";
import { useDispatch } from "react-redux";
import { API_PATHS } from "common/services/apiPaths";
import { applicationStatusOptions, feedbackStatusOptions } from "services/Recruit/data/dropdownData";
import { feedbackConstants } from "common/constant";
import { getLoggedInUser, isEmployee as checkIsEmployee } from "common/utils/roleUtils";
import InfoModal from "common/components/infoModel";

const Feedback = () => {
  const title = feedbackConstants.feedback;
  const TABLE_NAME = 'feedbacks'; // Define table name constant
  const [action, setAction] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedValues, setSelectedValues] = useState([]);
  const [searchboxOutside, setSearchboxOutside] = useState("");
  const [deleteModel, setDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [menuSelectedDeleteItem, setMenuSelectedDeleteItem] = useState([]);
  const [displaySearchData, setDisplaySearchData] = useState(false);
  const colors = globalStyles.colors;
  const recommendedActionDisplay = {
    proceed: {
      label: "Proceed",
      color: "#059669",
    },
    consider: {
      label: "Consider",
      color: "#D97706",
    },
    reject: {
      label: "Rejected",
      color: "#DC2626",
    },
    rejected: {
      label: "Rejected",
      color: "#DC2626",
    },
  };

  const handleDownloadPDF = async (id) => {
    try {
      const blob = await feedbackService.downloadFeedbackPDF(id);

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `feedback-${id}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      toast.success("PDF downloaded successfully");
    } catch (error) {
      toast.error("Failed to download PDF");
      console.error("PDF Download error:", error);
    }
  };

  const [permission] = HasAccess([
    accessModuleTitles.Applications,
  ]);
  const loggedInUser = getLoggedInUser();
  const isEmployee = checkIsEmployee(loggedInUser);
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(() => {
    const paginationState = JSON.parse(localStorage.getItem("paginationState"));
    return paginationState?.pageName === title && paginationState?.currentPage
      ? paginationState.currentPage
      : 1;
  });

  const [pageSize, setPageSize] = useState(() => {
    const paginationState = JSON.parse(localStorage.getItem("paginationState"));
    return paginationState?.pageName === title && paginationState?.pageSize
      ? paginationState.pageSize
      : 10;
  });
  const [sortColumn, setSortColumn] = useState(null); // Track the sorted column
  const [sortOrder, setSortOrder] = useState("");
  const [searchbox, setSearchbox] = useState(() => {
    const filters = getInitialFilterState(TABLE_NAME);
    return filters?.searchbox || null;
  });
  // State to track current status filter
  const [currentStatusFilter, setCurrentStatusFilter] = useState(() => {
    const filters = getInitialFilterState(TABLE_NAME);
    return filters?.currentStatusFilter || "";
  });

  // Save filters whenever they change
  useEffect(() => {
    const filters = {
      currentStatusFilter,
      searchbox: searchbox || "",
    };
    saveTableFilters(TABLE_NAME, filters);
  }, [currentStatusFilter, searchbox]);
  const [finalSearchedData, setFinalSearchedData] = useState([]);
  const [metadata, setMetadata] = useState({});
  const [infoModal, setInfoModal] = useState({ isOpen: false, message: "" });
  const [jobOpenings, setJobOpenings] = useState([]);

  useEffect(() => {
    const fetchJobOpenings = async () => {
      try {
        const result = await getApi(`${API_PATHS.RECRUITMENT_PROFILES}?allData=true`);
        setJobOpenings(result?.data?.data || []);
      } catch (e) {
        console.error("Failed to fetch job openings for feedback linking:", e);
      }
    };

    fetchJobOpenings();
  }, []);

  const EditData = async (value, id) => {
    try {
      let response = await putApi(
        `${API_PATHS.RECRUITMENT_FEEDBACK}${id}`,
        { rating: value }
      );
      if (response.status === 200) {
        toast.success("Feedback updated successfully");
        navigate("/recruitment/feedback");
      }
    } catch (e) {
      toast.error(constant.somethingWrong);
    }
  };

  const actionHeader = {
    Header: recruitConstant.actions,
    isSortable: false,
    center: true,
    disableRowClick: true,
    cell: ({ row }) => {
      return (
        <ActionMenu
          canView={true}
          canEdit={false}
          canDelete={permission?.delete}
          onView={() =>
            navigate(`/recruitment/feedback-create/${row?.values?._id}`, {
              state: { viewMode: true },
            })
          }
          onDelete={() => {
            setDelete(true);
            setSelectedValues([row?.values?._id]);
            setMenuSelectedDeleteItem([row?.values?._id]);
          }}
          customActions={[
            {
              label: "Download PDF",
              icon: <DownloadIcon />,
              onClick: (e) => {
                e.stopPropagation();
                handleDownloadPDF(row?.values?._id);
              },
            },
          ]}
        />
      );
    },
  };

  const onLinkClick = (id) => {
    return {
      pathname: `/recruitment/feedback-create/${id}`,
      state: { viewMode: true },
    };
  };

  const handleRowClick = useCallback(
    (row) => {
      navigate(`/recruitment/feedback-create/${row?.original?._id}`, {
        state: { viewMode: true },
      });
    },
    [navigate]
  );

  const openFeedbackView = useCallback(
    (feedbackId) => {
      if (!feedbackId) return;
      navigate(`/recruitment/feedback-create/${feedbackId}`, {
        state: { viewMode: true },
      });
    },
    [navigate]
  );

  const tableColumns = [
    {
      Header: "#",
      accessor: "_id",
      isSortable: false,
      width: 5,
    },
    {
      Header: feedbackConstants.candidateName,
      accessor: "candidateName",
      type: "text",
      cell: (cell) => {
        return (
          <Text
            as="span"
            cursor={cell?.value ? "pointer" : "default"}
            fontWeight="400"
            color={cell?.value ? colors.cta["100"] : "inherit"}
            _hover={cell?.value ? { textDecoration: "underline", color: colors.cta["100"] } : undefined}
            onClick={() => openFeedbackView(cell?.row?.original?._id)}
            whiteSpace="nowrap"
          >
            {cell?.value || "-"}
          </Text>)
      }
    },
    {
      Header: feedbackConstants.interviewRound,
      accessor: "interviewRound",
      type: "text",
      cell: (cell) => {
        console.log("feedbackCell", cell)
        return (
          <Box cursor={!isEmployee ? "pointer" : "default"} onClick={() =>
            !isEmployee && openFeedbackView(cell?.row?.original?._id)
          }>
            <Text>{cell?.row?.original?.interview?.round || "-"}</Text>
          </Box>
        )
      }
    },
    {
      Header: feedbackConstants.interviewId,
      accessor: "interviewId",
      type: "text",
      cell: (cell) => {
        console.log("feedbackCell", cell)
        return (
          <Box cursor={!isEmployee ? "pointer" : "default"} onClick={() =>
            !isEmployee && openFeedbackView(cell?.row?.original?._id)
          }>
            <Text>{cell?.row?.original?.interview?.interviewId || "-"}</Text>
          </Box>
        )
      }
    },

    {
      Header: feedbackConstants.postingTitle,
      accessor: "postingTitle",
      type: "text",
      disableRowClick: true,
      cell: (cell) => {
        const nestedJob = cell?.row?.original?.interview?.application?.job;
        const matchedJobOpening = jobOpenings.find(
          (job) =>
            job?._id === nestedJob?._id ||
            (cell?.row?.original?.jobId && job?.customId === cell?.row?.original?.jobId) ||
            (cell?.value && job?.postingTitle === cell?.value)
        );
        const jobDeleted = nestedJob?.deleted || matchedJobOpening?.deleted;
        const jobOpeningId =
          matchedJobOpening?._id ||
          cell?.row?.original?.interview?.application?.job?._id ||
          cell?.row?.original?.job?._id;
        let formattedTitle = cell?.value || "-";

        if (formattedTitle && formattedTitle !== "-") {
          // Handle "Other-" prefix by removing it and showing just the custom title
          if (formattedTitle.startsWith("Other-")) {
            formattedTitle = formattedTitle.replace("Other-", "");
          } else {
            // For regular titles, format by splitting hyphens and capitalizing
            formattedTitle = formattedTitle
              .split("-")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ");
          }
        }

        return (
          <Box>
            <Text
              as="span"
              cursor={!isEmployee && jobOpeningId ? "pointer" : "default"}
              color={!isEmployee && jobOpeningId ? colors.cta["100"] : "inherit"}
              fontWeight="400"
              onClick={() => {
                if (isEmployee) return;
                if (jobDeleted) {
                  setInfoModal({
                    isOpen: true,
                    message: "The job opening related to this feedback has already been deleted.",
                  });
                  return;
                }
                if (!jobOpeningId) return;
                sessionStorage.setItem("mode", "overview");
                navigate(`/recruitment/job-opening-create/${jobOpeningId}`);
              }}
              _hover={!isEmployee && jobOpeningId ? { textDecoration: "underline", color: colors.cta["100"] } : undefined}
            >
              {formattedTitle}
            </Text>
          </Box>
        );
      },
    },
    {
      Header: "Panel",
      accessor: "interviewPanelMembers",
      type: "text",
      cell: (cell) => {
        const panelMembers = Array.isArray(cell?.row?.original?.interviewPanelMembers)
          ? cell.row.original.interviewPanelMembers
          : [];
        const interviewersFallback = Array.isArray(cell?.row?.original?.interview?.interviewerIds)
          ? cell.row.original.interview.interviewerIds
          : [];
        const membersToDisplay = panelMembers.length > 0 ? panelMembers : interviewersFallback;

        const panelMemberNames = membersToDisplay
          .map((member) => {
            if (!member) return null;
            if (typeof member === "string") {
              const isObjectId = /^[a-f\d]{24}$/i.test(member);
              return isObjectId ? null : member;
            }

            const firstName = member?.firstName || member?.panelName?.firstName || "";
            const lastName = member?.lastName || member?.panelName?.lastName || "";
            const fullName = `${firstName} ${lastName}`.trim();

            return fullName || member?.name || member?.email || null;
          })
          .filter(Boolean)
          .join(", ");

        return (
          <Box cursor={!isEmployee ? "pointer" : "default"} onClick={() =>
            !isEmployee && openFeedbackView(cell?.row?.original?._id)
          }>
            <Text>{panelMemberNames || "-"}</Text>
          </Box>
        );
      },
    },
    {
      Header: feedbackConstants.rating,
      accessor: "rating",
      cell: (cell) => (
        <Box cursor={!isEmployee ? "pointer" : "default"} onClick={() =>
          !isEmployee && openFeedbackView(cell?.row?.original?._id)
        } >
          <Rating value={cell?.value}
          />
        </Box>
      ),
    },
    {
      Header: feedbackConstants.experienceInYears,
      accessor: "experience",
      type: "text",
      cell: (cell) => (
        <Box cursor={!isEmployee ? "pointer" : "default"} onClick={() =>
          !isEmployee && openFeedbackView(cell?.row?.original?._id)
        }>
          <Text>
            {cell?.value
              ? `${cell.value} ${Number(cell.value) === 1 ? "Year" : "Years"}`
              : "-"}
          </Text>
        </Box>
      ),
    },
    {
      Header: feedbackConstants.recommendedAction,
      accessor: "recommendedAction",
      type: "text",
      cell: (cell) => {
        const actionValue = cell?.value;
        const actionConfig = recommendedActionDisplay[actionValue] || null;
        const displayLabel = actionConfig?.label || actionValue || "-";
        const displayColor = actionConfig?.color || colors.text?.["200"];

        return (
          <Box cursor={!isEmployee ? "pointer" : "default"} onClick={() =>
            !isEmployee && openFeedbackView(cell?.row?.original?._id)
          }>
            <Box display="flex" alignItems="center" gap={2}>
              {actionValue ? (
                <Box
                  h={2}
                  w={2}
                  borderRadius="50%"
                  backgroundColor={displayColor}
                />
              ) : null}
              <Text
                as="span"
                color={displayColor}
                whiteSpace="nowrap"
                fontWeight="500"
                style={{ color: displayColor }}
                sx={{ color: `${displayColor} !important` }}
              >
                {displayLabel}
              </Text>
            </Box>
          </Box>
        );
      },
    },
    {
      Header: feedbackConstants.createdBy,
      accessor: "createBy",
      cell: (cell) => (
        <Box cursor={!isEmployee ? "pointer" : "default"} onClick={() =>
          !isEmployee && openFeedbackView(cell?.row?.original?._id)
        }>
          <Text>{cell?.value?.firstName + " " + cell?.value?.lastName || "-"}</Text>
        </Box>
      ),
    },
    // {
    //   Header: recruitConstant.postingTitle,
    //   accessor: "title",
    //   type: "text",
    //   formikType: "",
    //   cell: (cell) => {
    //     const formattedTitle = cell?.value
    //       ?.split("-") // Split by hyphen
    //       .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
    //       .join(" "); // Join with space

    //     return (
    //       <div cursor={"pointer"} onClick={() => navigate(`/recruitment/application-create/${cell?.row?.values?._id}`)} className="link">
    //         <Text color={colors.cta["100"]}>{formattedTitle}</Text>
    //       </div>
    //     );
    //   },
    //   // cell: (cell) => (
    //   //   <div className="selectOpt">
    //   //     <Text>{cell?.value ?? '-'}</Text>
    //   //   </div>
    //   // ),
    // },

    {
      Header: recruitConstant.createdAt,
      accessor: "createdAt",
      type: "text",
      formikType: "",
      cell: (cell) => (
        <Box>
          <Text cursor={!isEmployee ? "pointer" : "default"} onClick={() =>
            !isEmployee && openFeedbackView(cell?.row?.original?._id)
          }
            me="10px" fontSize="sm" fontWeight="700">
            <span>{DateFormatter(cell?.value)}</span>
          </Text>
        </Box>
      ),
    },
    {
      Header: recruitConstant.modifiedAt,
      accessor: "updatedAt",
      type: "text",
      formikType: "",
      cell: (cell) => (
        <Box>
          <Text cursor={!isEmployee ? "pointer" : "default"} onClick={() =>
            !isEmployee && openFeedbackView(cell?.row?.original?._id)
          }
            me="10px" fontSize="sm" fontWeight="700">
            <span>{DateFormatter(cell?.value)}</span>
          </Text>
        </Box>
      ),
    },

    ...(permission?.update || permission?.delete
      ? [actionHeader]
      : []),
  ];

  const hiddenEmployeeHeaders = [
    feedbackConstants.interviewId,
    feedbackConstants.createdBy,
    recruitConstant.createdAt,
    recruitConstant.modifiedAt,
  ];

  const employeePreferredHeaders = [
    "#",
    feedbackConstants.candidateName,
    feedbackConstants.rating,
    feedbackConstants.interviewRound,
    feedbackConstants.postingTitle,
    feedbackConstants.experienceInYears,
    "Panel",
    feedbackConstants.recommendedAction,
  ];

  const visibleTableColumns = isEmployee
    ? employeePreferredHeaders
        .map((header) =>
          tableColumns.find(
            (column) =>
              column?.Header === header &&
              !hiddenEmployeeHeaders.includes(column?.Header)
          )
        )
        .filter(Boolean)
    : tableColumns;

  const adminDefaultHeaders = [
    feedbackConstants.candidateName,
    feedbackConstants.postingTitle,
    feedbackConstants.interviewRound,
    feedbackConstants.rating,
    feedbackConstants.experienceInYears,
    feedbackConstants.recommendedAction,
    feedbackConstants.createdBy,
    recruitConstant.createdAt,
    recruitConstant.actions,
  ];

  const defaultVisibleColumns = isEmployee
    ? visibleTableColumns
    : adminDefaultHeaders
        .map((header) => visibleTableColumns.find((column) => column?.Header === header))
        .filter(Boolean);

  const fetchData = async (
    page = currentPage,
    limit = pageSize,
    sortKey = sortColumn,
    order = sortOrder,
    searchTerm = "",
    fetchAllData = false,
    status = ""
  ) => {
    setIsLoading(true);

    let endpoint = `api/recruitment/feedback?page=${page}&limit=${limit}`;

    if (fetchAllData) {
      endpoint = `api/recruitment/feedback?allData=true`;
    }

    if (sortKey) {
      const sortParam = order === "desc" ? `-${sortKey}` : sortKey;
      endpoint += `&sort=${sortParam}`;
    }

    if (searchTerm) {
      endpoint += `&search=${encodeURIComponent(searchTerm)}`;
    }

    if (status && status.trim() !== "") {
      // For feedback, we use recommendedAction instead of status
      // Normalize status to lowercase for consistency with backend
      const normalizedStatus = status.toLowerCase().trim();
      endpoint += `&recommendedAction=${encodeURIComponent(normalizedStatus)}`
    }

    try {
      const result = await getApi(endpoint);
      const data = result?.data?.data || [];
      if (fetchAllData) {
        setFinalSearchedData(data);
      } else {

        setData(data || []);
        setMetadata(result?.data?.metadata);
      }
    } catch (e) {
      toast.error(recruitConstant.errorMsg);
      console.error("Error fetching job openings:", e);
    } finally {
      setIsLoading(false);
    }
  };
  // Handler for status filter change
  const handleStatusFilterChange = useCallback(
    (selectedStatus) => {
      // Update current status filter state
      setCurrentStatusFilter(selectedStatus);
      setCurrentPage(1);
    },
    []
  );

  // Fetch data when filters or pageSize change
  useEffect(() => {
    // When filters change, reset to page 1 and fetch
    fetchData(
      1, // Always start from page 1 when filters change
      pageSize,
      sortColumn,
      sortOrder,
      searchbox || "",
      false,
      currentStatusFilter || ""
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    pageSize, // Page size change
    currentStatusFilter, // Status filter change
    sortColumn, // Sort column change
    sortOrder, // Sort order change
  ]);

  const handleSearchChange = (term) => {
    const trimmedTerm = term?.trim() || "";
    setSearchbox(trimmedTerm);

    const pageToFetch = trimmedTerm === "" ? currentPage : 1;
    if (trimmedTerm !== "" && currentPage !== 1) {
      setCurrentPage(1);
    }
    // Include current status filter when searching
    fetchData(pageToFetch, pageSize, sortColumn, sortOrder, trimmedTerm, false, currentStatusFilter || "");
  };

  const handleSortChange = (accessorKey) => {
    let newSortOrder = "asc";

    if (sortColumn === accessorKey) {
      newSortOrder = sortOrder === "asc" ? "desc" : "asc";
    }

    setSortColumn(accessorKey);
    setSortOrder(newSortOrder);

    // Include current status filter when sorting
    fetchData(currentPage, pageSize, accessorKey, newSortOrder, searchbox, false, currentStatusFilter || "");
  };

  // "api/recruitment/feedbackdeleteMany"

  const handleDeleteApplication = async (ids) => {
    try {
      setDelete(false);
      let response = await deleteManyApi("api/recruitment/feedback/interviews/deleteMany", ids);
      if (response.status === 200) {
        setSelectedValues([]);
        fetchData(currentPage, pageSize);
        toast.success(
          `${menuSelectedDeleteItem.length > 0
            ? constant.feedback
            : selectedValues && selectedValues.length > 1
              ? `${constant.feedback}s`
              : constant.feedback
          } ${constant.deletedSuccessfully}`
        );
        setAction((pre) => !pre);
      }
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setMenuSelectedDeleteItem([]);
    }
  };

  const [columns, setColumns] = useState([...visibleTableColumns]);
  const [selectedColumns, setSelectedColumns] = useState([...defaultVisibleColumns]);
  const dataColumn = columns?.filter((item) =>
    selectedColumns?.find((colum) => colum?.Header === item.Header)
  );

  function closeDeleteModal() {
    setMenuSelectedDeleteItem([]);
    setDelete(false);
  }

  return (
    <div>
      <CommonCheckTable
        title={title}
        showInlineTitle={true}
        inlineTitle={
          isEmployee
            ? `My Feedbacks (${metadata?.totalRecords ?? data?.length ?? 0})`
            : `Feedbacks (${metadata?.totalRecords ?? data?.length ?? 0})`
        }
        isLoading={isLoading}
        columnData={columns}
        onLinkClick={onLinkClick}
        dataColumn={dataColumn}
        allData={data}
        tableData={data}
        // searchDisplay={displaySearchData}
        setSearchDisplay={setDisplaySearchData}
        // searchedDataOut={searchedData}
        // setSearchedDataOut={setSearchedData}
        tableCustomFields={[]}
        access={permission}
        action={action}
        setAction={setAction}
        onRowClick={isEmployee ? undefined : handleRowClick}
        disableDefaultCellNavigation={isEmployee}
        selectedColumns={selectedColumns}
        setSelectedColumns={setSelectedColumns}
        isOpen={isOpen}
        onClose={onClose}
        // state={state}
        onOpen={onOpen}
        selectedValues={selectedValues}
        setSelectedValues={setSelectedValues}
        setDelete={setDelete}
        fetchData={fetchData}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        // AdvanceSearch={
        //   <Button
        //     variant="outline"
        //     className="advance-search-button"
        //     colorScheme="brand"
        //     leftIcon={<SearchIcon />}
        //     mt={{ sm: "5px", md: "0" }}
        //     size="sm"
        //     onClick={() => setAdvanceSearch(true)}
        //   >
        //     {constant.advanceSearch}
        //   </Button>
        // }
        // getTagValuesOutSide={getTagValuesOutSide}
        searchboxOutside={searchboxOutside}
        // setGetTagValuesOutside={setGetTagValuesOutside}
        sortOrder={sortOrder}
        searchbox={searchbox}
        setSearchbox={setSearchbox}
        setSearchboxOutside={setSearchboxOutside}
        finalSearchedData={finalSearchedData}
        setFinalSearchedData={setFinalSearchedData}
        metadata={metadata}
        handleSortChange={handleSortChange}
        handleSearchChange={handleSearchChange}
        filterStatusOptions={feedbackStatusOptions}
        statusFilter={true}
        handleStatusFilterChange={handleStatusFilterChange}
        currentStatusFilter={currentStatusFilter}
        isDynamic={true}
      />

      <CommonDeleteModel
        isOpen={deleteModel}
        onClose={() => closeDeleteModal()}
        type={
          menuSelectedDeleteItem.length > 0
            ? constant.feedback
            : selectedValues && selectedValues.length > 1
              ? `${constant.feedback}s`
              : constant.feedback
        }
        handleDeleteData={handleDeleteApplication}
        ids={selectedValues}
        onCancel={() => setSelectedValues([])} // Clear selections when modal is closed without deletion
      />
      <InfoModal
        isOpen={infoModal.isOpen}
        onClose={() => setInfoModal({ isOpen: false, message: "" })}
        message={infoModal.message}
      />
    </div>
  );
};

export default Feedback;
